export default __webpack_public_path__ + "static/1stackedbench-b4afe2bad20a5c1bec8f329c9bc5310c.png";